export default "__VITE_PUBLIC_ASSET__8c174b2f__"